// Define role levels and their associated roles
const AccessLevels = {
    SUPER_ADMINS_ONLY: ['SUPER_ADMIN'],
    HQ_STAFF_ONLY: ['SUPER_ADMIN','HQ_STAFF','ORGANIZATION_ADMIN'],
    ALL_ADMINS_ONLY: ['SUPER_ADMIN', 'ORGANIZATION_ADMIN','HQ_STAFF'],
    AGENT_STAFF_ONLY: ['SUPER_ADMIN', 'ORGANIZATION_ADMIN', 'ORGANIZATION_STAFF',"BRANCH_ADMIN"],
    ALL_STAFF: ['SUPER_ADMIN', 'ORGANIZATION_ADMIN', 'ORGANIZATION_STAFF','BRANCH_STAFF','HQ_STAFF'],
    BRANCH_STAFF_ONLY: ['SUPER_ADMIN','BRANCH_STAFF','BRANCH_ADMIN'],
    ALLOW_ALL: ['SUPER_ADMIN', 'ORGANIZATION_ADMIN', 'ORGANIZATION_STAFF','BRANCH_ADMIN','BRANCH_STAFF','HQ_STAFF',],
  };
   
  export default AccessLevels;